module.exports = __webpack_public_path__ + "static/media/carrorama-starter.16ac423c.webp";